import { createStore } from 'redux';
import PublicApp from 'Site/State/App';
const Store = createStore(PublicApp);
export default Store;



// WEBPACK FOOTER //
// ./client/Site/State/Store.js